

import {
  Box,
  Divider,
  LinearProgress,
  useMediaQuery,
  Button,
  CircularProgress,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../../components/CustomText";
import back from "../../../../assets/back.svg";
import projecticon from "../../../../assets/Projects/projecticon.svg";
import Progress from "../../../../assets/Projects/Progress.svg";
import document1 from "../../../../assets/document1.svg";
import document2 from "../../../../assets/Projects/document2.png";
import AddIcon from "@mui/icons-material/Add";
import StatusDropdown from "../../../../components/StatusDropdown";
import person1 from "../../../../assets/Dashboard/person1.svg";
import activity from "../../../../assets/Projects/activity.png";
import { showUnderDevelopment } from "../../../../components/alerts.js";
import { useState,useEffect } from "react";
  import AttachFileIcon from "@mui/icons-material/AttachFile";
import emptyperson from "../../../../assets/emptyperson.jpeg";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { BASE_URL } from "../../../../components/BaseUrl";
import TaskStatusDropdown from "../../../../components/TaskStatusDropdown.js";
import {toast} from "react-hot-toast";
import MapModal from "./MapModal.js";
import FaceScanModal from "./faceScanModal.js";
import EvidenceModal from "./ProofModal.js";
import CustomButton from "../../../../components/CustomButton.js";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";
const TaskDetails = ({ task, onBack, refreshTaskDetails }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { t, i18n } = useTranslation();
    const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [comments, setComments] = useState([]);
const [status, setStatus] = useState(task?.status || "");
const [startEventData, setStartEventData] = useState(null);
const [completeEventData, setCompleteEventData] = useState(null);
const [updatingTaskStatus, setUpdatingTaskStatus] = useState(false);
  // useEffect(() => {
  //   if (task?.comments) {
  //     setComments(task.comments);
  //   }
  // }, [task]);
useEffect(() => {
  if (task?.comments) {
    const sorted = [...task.comments].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    setComments(sorted);
  }
}, [task]);
  const [taskData, setTaskData] = useState(task);

useEffect(() => {
  if (task?.status) {
    console.log(`♻️ [STEP 9 - TASK PROP SYNC] task prop updated, real status from backend/DB:`, task.status, "| my_status:", task?.my_status);
    setStatus(task.status);
  }
}, [task]);

useEffect(() => {
  setStartEventData(null);
  setCompleteEventData(null);
}, [task?.id]);

  const [newComment, setNewComment] = useState("");
  const [sending, setSending] = useState(false);


    // Example: "11 Sept 2025"
const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const localDateTime = convertUTCToLocalDateTime(dateString, { locale: "en-GB" });
  return localDateTime === "—" ? "-" : localDateTime;
};


const [commentFile, setCommentFile] = useState(null);
const [commentFileUrl, setCommentFileUrl] = useState(null);

const [uploadingAttachment, setUploadingAttachment] = useState(false);
const renderValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

const formatDurationCompact = (totalMinutes) => {
  if (totalMinutes == null || totalMinutes === "") return null;
  const n = Math.floor(Number(totalMinutes));
  if (!Number.isFinite(n) || n < 0) return null;
  if (n === 0) return "0min";

  const hours = Math.floor(n / 60);
  const minutes = n % 60;

  if (hours > 0 && minutes > 0) return `${hours}h ${minutes}min`;
  if (hours > 0) return `${hours}h`;
  return `${minutes}min`;
};

const renderDurationMinutes = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Math.floor(Number(value));
  if (!Number.isFinite(n)) return renderValue(value);
  const formatted = formatDurationCompact(n);
  return formatted ?? "-";
};

const renderBooleanLabel = (value) => {
  if (value === true) return t("taskStartDetails.yes");
  if (value === false) return t("taskStartDetails.no");
  return "-";
};

const humanizeStatus = (value) =>
  String(value)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

const renderStatusLabel = (value) => {
  if (!value) return "-";
  const normalized = String(value).toLowerCase();
  const key = `taskStartDetails.status.${normalized}`;
  const translated = t(key);
  if (translated !== key) return translated;
  return humanizeStatus(normalized);
};

const toArray = (value) => (Array.isArray(value) ? value : []);

const isPdfUrl = (url) =>
  typeof url === "string" && url.toLowerCase().split("?")[0].endsWith(".pdf");

const renderEvidenceGallery = (files) => {
  const list = toArray(files).filter((url) => typeof url === "string" && url);
  if (list.length === 0) return "-";

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "flex-end" }}>
      {list.map((url, idx) =>
        isPdfUrl(url) ? (
          <a
            key={idx}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-flex" }}
          >
            <Box
              component="img"
              src={document1}
              alt="Evidence document"
              sx={{
                width: 44,
                height: 44,
                objectFit: "contain",
                borderRadius: "8px",
                border: "1px solid #E4E6EF",
                cursor: "pointer",
                p: 0.5,
                backgroundColor: "#F9FAFB",
              }}
            />
          </a>
        ) : (
          <a
            key={idx}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-flex" }}
          >
            <Box
              component="img"
              src={url}
              alt="Evidence"
              crossOrigin="anonymous"
              sx={{
                width: 44,
                height: 44,
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #E4E6EF",
                cursor: "pointer",
              }}
            />
          </a>
        )
      )}
    </Box>
  );
};

const resolveFaceImageUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  const uploadsPathIndex = url.indexOf("/api/uploads/");
  if (uploadsPathIndex !== -1) {
    return `${BASE_URL}${url.slice(uploadsPathIndex + 4)}`; // keep "/api/uploads/..."
  }

  if (url.startsWith("http://") || url.startsWith("https://")) {
    try {
      const source = new URL(url);
      const base = new URL(BASE_URL);
      // If backend returns a different host for uploads, rewrite to current API host.
      if (source.pathname.startsWith("/api/uploads/") && source.origin !== base.origin) {
        return `${BASE_URL}${source.pathname.replace(/^\/api/, "")}`;
      }
    } catch (err) {
      console.warn("⚠️ Failed to parse face image URL:", url, err);
    }
    return url;
  }

  const uploadsIndex = url.indexOf("/uploads/");
  if (uploadsIndex !== -1) {
    return `${BASE_URL}${url.slice(uploadsIndex)}`;
  }
  return null;
};

const buildStartDetailsFromTask = (taskData) => {
  const timing = taskData?.timing || {};
  const attendance = taskData?.attendance || {};
  const validationStart = taskData?.my_validation_start || {};
  const fallbackValidation = taskData?.validation || {};
  // The task-level `validation` field always reports "pending" (it reflects the moment an
  // event is created, not its current state) — the real, live review status lives on the
  // matching biometric_task_events row, same as it does on the admin side.
  const startEvent = toArray(taskData?.events).find((e) => e?.event_type === "start");
  const hasData =
    taskData?.my_started_at ||
    timing?.actual_start_at ||
    Object.keys(validationStart).length > 0;

  if (!hasData) return null;

  return {
    started_at: taskData?.my_started_at || timing?.actual_start_at || null,
    timing: {
      scheduled_start_at: timing?.scheduled_start_at || taskData?.start_at || null,
      actual_start_at: timing?.actual_start_at || taskData?.my_started_at || null,
      start_time_status:
        validationStart?.time_status || timing?.start_time_status || attendance?.start_status || null,
      start_delay_minutes:
        validationStart?.start_delay_minutes ??
        timing?.start_delay_minutes ??
        attendance?.start_delay_minutes ??
        null,
    },
    validation: {
      face_validated: validationStart?.face_validated ?? fallbackValidation?.face_validated ?? null,
      location_validated:
        validationStart?.location_validated ?? fallbackValidation?.location_validated ?? null,
      system_validation_status:
        validationStart?.system_validation_status ??
        fallbackValidation?.system_validation_status ??
        null,
      review_status: startEvent?.review_status ?? fallbackValidation?.review_status ?? null,
      face_image_url: resolveFaceImageUrl(
        validationStart?.face_image_url || fallbackValidation?.face_image_url
      ),
    },
  };
};

const buildCompleteDetailsFromTask = (taskData) => {
  const timing = taskData?.timing || {};
  const attendance = taskData?.attendance || {};
  const validationEnd = taskData?.my_validation_end || {};
  const fallbackValidation = taskData?.validation || {};
  const endEvent = toArray(taskData?.events).find((e) => e?.event_type === "end");
  const hasData =
    taskData?.my_ended_at ||
    timing?.actual_end_at ||
    Object.keys(validationEnd).length > 0;

  if (!hasData) return null;

  return {
    completed_at: taskData?.my_ended_at || timing?.actual_end_at || null,
    duration_minutes: taskData?.attendance?.task_duration_minutes ?? null,
    timing: {
      scheduled_end_at: timing?.scheduled_end_at || taskData?.end_at || null,
      actual_end_at: timing?.actual_end_at || taskData?.my_ended_at || null,
      completion_time_status:
        validationEnd?.time_status || timing?.completion_time_status || attendance?.end_status || null,
      completion_early_minutes: validationEnd?.completion_early_minutes ?? null,
      completion_delay_minutes:
        validationEnd?.completion_delay_minutes ??
        timing?.completion_delay_minutes ??
        attendance?.end_delay_minutes ??
        null,
    },
    validation: {
      face_validated: validationEnd?.face_validated ?? fallbackValidation?.face_validated ?? null,
      location_validated:
        validationEnd?.location_validated ?? fallbackValidation?.location_validated ?? null,
      system_validation_status:
        validationEnd?.system_validation_status ??
        fallbackValidation?.system_validation_status ??
        null,
      review_status: endEvent?.review_status ?? fallbackValidation?.review_status ?? null,
      face_image_url: resolveFaceImageUrl(
        validationEnd?.face_image_url || fallbackValidation?.face_image_url
      ),
      evidence_files_count: endEvent?.evidence_files?.length ?? null,
      evidence_files: toArray(endEvent?.evidence_files),
    },
  };
};

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
setUploadingAttachment(true);
  try {
    const formData = new FormData();
    formData.append("image", file);

    const res = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (!data.error && data.data?.url) {
toast.success(t("taskAlerts.attachmentUploaded"));
      setCommentFile(file);
      setCommentFileUrl(data.data.url);
    } else {
toast.error(t("taskAlerts.uploadFailed"));
    }
  } catch (err) {
    console.error("❌ Upload error:", err);
toast.error(t("taskAlerts.fileUploadError"));
  }
  finally {
    setUploadingAttachment(false); // hide loader
  }
};
const startDetails = startEventData || buildStartDetailsFromTask(task);
const completeDetails = completeEventData || buildCompleteDetailsFromTask(task);

const removeAttachment = () => {
  setCommentFileUrl(null);
};
const handleAddComment = async () => {
  if (!newComment.trim() && !commentFileUrl) return;

  setSending(true);
  try {
    const body = {
      body: newComment,
      attachments: commentFileUrl ? [commentFileUrl] : [],
    };

    const res = await fetch(
      `${BASE_URL}/task-management/worker/tasks/${task.id}/comments`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
        body: JSON.stringify(body),
      }
    );

    const data = await res.json();

    if (!data.error) {
      // setComments((prev) => [...prev, data.data.comment]);
            setComments((prev) => [data.data.comment, ...prev]);

      setNewComment("");
      setCommentFile(null);
      setCommentFileUrl(null);
    } else {
toast.error(t("taskAlerts.commentFailed"));
    }
  } catch (err) {
    console.error("❌ Error adding comment:", err);
toast.error(t("taskAlerts.commentFailed"));
  } finally {
    setSending(false);
  }
};

  const [mapOpen, setMapOpen] = useState(false);
  const [faceOpen, setFaceOpen] = useState(false);
  const [geoData, setGeoData] = useState(null);
  const [flowType, setFlowType] = useState(null); // "start" or "complete"
const [evidenceOpen, setEvidenceOpen] = useState(false);
const [evidenceFiles, setEvidenceFiles] = useState([]);

const handleStatusChange = (status) => {
  if (updatingTaskStatus) return;
  if (status === "start") {
    setFlowType("start");
    setMapOpen(true);
  } else if (status === "completed") {
    setFlowType("complete");
    setMapOpen(true);
  }
};

  
  const handleMapContinue = (data) => {
    console.log("📍 [STEP 1 - MAP] Location captured:", data);
    setGeoData(data);
    setMapOpen(false);
    setFaceOpen(true);
  };



const handleFaceContinue = async (faceData) => {
  console.log("🧠 [TASK DETAILS] handleFaceContinue called");
  console.log("🧠 [TASK DETAILS] faceData:", faceData);
  console.log("🧠 [TASK DETAILS] flowType:", flowType);
  console.log("🧠 [TASK DETAILS] geoData:", geoData);

  setFaceOpen(false);

  if (flowType === "start") {
    const body = {
      ...faceData,
      ...geoData,
      notes: "Starting task from office location",
    };

    console.log("🧠 [TASK DETAILS] START body:", body);
    console.log("🧠 [TASK DETAILS] START face_file_id URL:", body?.face_file_id);

    await submitTaskStatus("start", body);
  } else if (flowType === "complete") {
    console.log("📸 [STEP 2 - FACE] Face captured, moving to evidence step:", faceData);
    setEvidenceOpen(true);
    setPendingFaceData(faceData);
  }
};


const [pendingFaceData, setPendingFaceData] = useState(null);

const handleEvidenceSave = async (evidenceUrls) => {
  console.log("🖼️ [STEP 3 - EVIDENCE] Evidence uploaded:", evidenceUrls);
  setEvidenceOpen(false);

  const body = {
    ...pendingFaceData,
    ...geoData,
    evidence: evidenceUrls,
    local_timestamp: new Date().toISOString(),
    notes: "Task completed successfully with all deliverables",
  };

  console.log("📦 [STEP 4 - COMPLETE BODY] Final request body for /complete:", body);

  await submitTaskStatus("complete", body);
};

// const submitTaskStatus = async (type, body) => {
//   const endpoint =
//     type === "start"
//       ? `${BASE_URL}/task-management/worker/tasks/${task.id}/start`
//       : `${BASE_URL}/task-management/worker/tasks/${task.id}/complete`;

//   console.log(`📤 Sending task ${type} request:`, body);

//   try {
//     const res = await fetch(endpoint, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${decryptedToken}`,
//       },
//       body: JSON.stringify(body),
//     });

//     const data = await res.json();
// if (!data.error) {
//   toast.success(
//     type === "start"
//       ? t("taskAlerts.taskStartSuccess")
//       : t("taskAlerts.taskCompleteSuccess")
//   );  // ✅ Instantly update local status
//   setStatus(type === "start" ? "in_progress" : "completed");
// }
// else {
//       toast.error(data.message || `Failed to ${type} task`);
//     }
//   } catch (err) {
//     console.error("❌ Network error:", err);
//     toast.error(`Error ${type}ing task`);
//   }
// };



const submitTaskStatus = async (type, body) => {
  setUpdatingTaskStatus(true);
  console.log(`🚀 [STEP 5 - SUBMIT ${type.toUpperCase()}] Calling API with body:`, body);
  try {
    const endpoint =
      type === "start"
        ? `${BASE_URL}/task-management/worker/tasks/${task.id}/start`
        : `${BASE_URL}/task-management/worker/tasks/${task.id}/complete`;

    console.log(`🌐 [STEP 5 - ENDPOINT] ${endpoint}`);

    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: JSON.stringify(body),
    });

    console.log(`📡 [STEP 6 - HTTP STATUS] ${res.status}`);

    const data = await res.json();

    console.log(`📥 [STEP 6 - RAW RESPONSE] Full response JSON:`, data);
    if (type === "complete" && data?.data) {
      console.log(`🔎 [STEP 6 - COMPLETE DETAILS] task_status:`, data.data.task_status);
      console.log(`🔎 [STEP 6 - COMPLETE DETAILS] task_fully_completed:`, data.data.task_fully_completed);
      console.log(`🔎 [STEP 6 - COMPLETE DETAILS] completion_policy:`, data.data.completion_policy);
      console.log(`🔎 [STEP 6 - COMPLETE DETAILS] completion_stats:`, data.data.completion_stats);
      console.log(`🔎 [STEP 6 - COMPLETE DETAILS] assignment_status:`, data.data.assignment_status);
    }

    // ❌ Backend error → show API message
    if (data.error) {
      console.log(`❌ [STEP 6 - ERROR] Backend returned error:`, data.message);
      toast.error(data.message || "Something went wrong");
      return;
    }

    // ✅ Success → show translated message (EN/ES), fallback to API message
    toast.success(
      type === "start"
        ? t("taskAlerts.taskStartSuccess", { defaultValue: data.message })
        : t("taskAlerts.taskCompleteSuccess", { defaultValue: data.message })
    );

    // update local status only on success
    console.log(`🔧 [STEP 7 - LOCAL STATE] setStatus hardcoded to:`, type === "start" ? "in_progress" : "completed");
    setStatus(type === "start" ? "in_progress" : "completed");

    // Always refresh from details API so UI matches backend source of truth.
    if (typeof refreshTaskDetails === "function" && task?.id) {
      console.log(`♻️ [STEP 8 - REFRESH] Calling refreshTaskDetails(${task.id})...`);
      await refreshTaskDetails(task.id);
      console.log(`♻️ [STEP 8 - REFRESH DONE] refreshTaskDetails finished`);
      // Keep rendering tied to refreshed task details payload.
      setStartEventData(null);
      setCompleteEventData(null);
      return;
    }

    // Fallback if parent refresh function is unavailable.
    if (type === "start") {
      setStartEventData({
        timing: data?.data?.timing || null,
        validation: data?.data?.validation || null,
        started_at: data?.data?.started_at || null,
      });
    } else {
      setCompleteEventData({
        timing: data?.data?.timing || null,
        validation: data?.data?.validation || null,
        completed_at: data?.data?.completed_at || null,
        duration_minutes: data?.data?.duration_minutes,
      });
    }

  } catch (err) {
    console.error("Network / JS error:", err);

    // ❌ network-level error (no API response)
    toast.error("Network error. Please try again.");
  } finally {
    setUpdatingTaskStatus(false);
  }
};


// const submitTaskStatus = async (type, body) => {
//   console.log("🚀 [SUBMIT] submitTaskStatus called");
//   console.log("🚀 [SUBMIT] type:", type);
//   console.log("🚀 [SUBMIT] body:", body);
//   console.log("🚀 [SUBMIT] token exists:", !!decryptedToken);

//   const endpoint =
//     type === "start"
//       ? `${BASE_URL}/task-management/worker/tasks/${task.id}/start`
//       : `${BASE_URL}/task-management/worker/tasks/${task.id}/complete`;

//   console.log("🚀 [SUBMIT] endpoint:", endpoint);

//   try {
//     const res = await fetch(endpoint, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${decryptedToken}`,
//       },
//       body: JSON.stringify(body),
//     });

//     console.log("📡 [SUBMIT] HTTP status:", res.status);

//     const data = await res.json();
//     console.log("📦 [SUBMIT] response JSON:", data);

//     if (!data.error) {
//       console.log("✅ [SUBMIT] SUCCESS");
//       setStatus(type === "start" ? "in_progress" : "completed");
//     } else {
//       console.error("❌ [SUBMIT] BACKEND ERROR:", data);
//     }
//   } catch (err) {
//     console.error("🔥 [SUBMIT] JS / NETWORK ERROR:", err);
//   }
// };





  if (!task) {
    return (
         <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
      }}
    >
      <CircularProgress size={40} /> 
    </Box>
    );
  }
  return (
    <>
    

      <Box sx={{ p: isMobile ? 1 : 0 }}>
        {/* Back Bar */}
         <Box
          sx={{
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            minHeight: 55,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
            }}
            onClick={onBack}
          >
            <img src={back} style={{ width: 30, height: 30 }} alt="back" />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: "14px",
                color: "#626F86",
              }}
            >      {t("projectManagement.allTasks")} / {task.title}
            </CustomText>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 3,
            alignItems: isMobile ? "flex-start" : "stretch",
          }}
        >
          <Box
            flex={2}
            sx={{
              backgroundColor: "#fff",
              p: 2,
              borderRadius: 2,
              height: "100%",
              border: "1px solid #E4E6EF",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center",justifyContent:"space-between" ,flexWrap:"wrap", pt: 1}}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1,}}>
              {/* <img src={projecticon} style={{ width: 25, height: 25 }} /> */}
              <CustomText
                sx={{
                  fontSize: 16,
                  color: "#172B4D",
                  fontWeight: 500,
                  mb: 0,
                  fontFamily: "Poppins, sans-serif",
                }}
              >
 {task.id}              </CustomText>
                  </Box>
              <Box>
           



      {status && (
  <>
    <TaskStatusDropdown
      currentStatus={status}
      options={
        status === "in_progress"
          ? ["completed"]
          : ["start", "completed"]
      }

      onChange={handleStatusChange}
    />






  </>
      )}   
              {/* </Box> */}

              </Box>
          
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                mt: 2.5,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.taskName")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "right",
                }}
              >
                {renderValue(task.title)}
              </CustomText>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mb: 2,
                gap: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                  flexShrink: 0,
                }}
              >
                {t("projectManagement.description")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "right",
                  lineHeight: 1.5,
                  maxWidth: "70%",
                }}
              >
                {renderValue(task.description)}
              </CustomText>
            </Box>

           
      

            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.taskDetails")}
            </CustomText>

     <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.assignedOn")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
{formatDateTime(task.assigned_on)}
     </CustomText>{" "}
            </Box>


  <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                  {t("projectManagement.assignedBy")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
  {task.assigned_by_name || "—"}
              </CustomText>{" "}
            </Box>


               <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.status")}
              </CustomText>
                 <Box sx={{ pointerEvents: "none" }}>

{status && (
  <>
    <StatusDropdown currentStatus={status} />
    </>)}
               {" "}
              </Box>
            </Box>


      
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                  {t("projectManagement.priority")}
                 
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "right",
                  textTransform: "capitalize",
                }}
              >
          <StatusDropdown currentStatus={task.priority} />
              </CustomText>{" "}
            </Box>

            {task.status === "completed" && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("projectManagement.productivityRating")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "right",
                      textTransform: "capitalize",
                    }}
                  >
                    {renderValue(task.productivity_rating)}
                  </CustomText>{" "}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 2,
                    gap: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                      flexShrink: 0,
                    }}
                  >
                    {t("projectManagement.ratingNotes")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "right",
                      lineHeight: 1.5,
                      maxWidth: "70%",
                    }}
                  >
                    {renderValue(task.productivity_notes)}
                  </CustomText>{" "}
                </Box>
              </>
            )}

             <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                  {t("projectManagement.location")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "right",
                }}
              >
                {/* {task.end_at}{" "} */}
              {task.location_address}
              </CustomText>{" "}
            </Box>

  <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
              {t("startTask")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
{formatDateTime(startDetails?.started_at || task.start_at)}
     </CustomText>{" "}
            </Box>


                  <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("endTask")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
                {/* {task.end_at}{" "} */}
                 {formatDateTime(completeDetails?.completed_at || task.end_at)}
              </CustomText>{" "}
            </Box>

            {startDetails?.timing && (
              <Box
                sx={{
                  border: "2px solid  #091E4224",
                  borderRadius: "10px",
                  px: 2,
                  py: 2,
                  mt: 1.5,
                  mb: 2.5,
                  // backgroundColor: "#FBFCFE",
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 19,
                    mb: 2,
                    mt: 0.5,
                    fontWeight: 700,
                    color: "#003149",
                    textAlign: "left",
                  }}
                >
                  {t("taskStartDetails.title")}
                </CustomText>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskStartDetails.scheduledStart")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                    {formatDateTime(startDetails?.timing?.scheduled_start_at)}
                  </CustomText>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskStartDetails.actualStart")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                    {formatDateTime(startDetails?.timing?.actual_start_at)}
                  </CustomText>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskStartDetails.startStatus")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left", textTransform: "capitalize" }}>
                    {renderStatusLabel(startDetails?.timing?.start_time_status)}
                  </CustomText>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskStartDetails.delayMinutes")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                    {renderDurationMinutes(startDetails?.timing?.start_delay_minutes)}
                  </CustomText>
                </Box>

                {startDetails?.validation && (
                  <>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskStartDetails.faceValidated")}
                      </CustomText>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                        {renderBooleanLabel(startDetails?.validation?.face_validated)}
                      </CustomText>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskStartDetails.locationValidated")}
                      </CustomText>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                        {renderBooleanLabel(startDetails?.validation?.location_validated)}
                      </CustomText>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskStartDetails.systemValidationStatus")}
                      </CustomText>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left", textTransform: "capitalize" }}>
                        {renderStatusLabel(startDetails?.validation?.system_validation_status)}
                      </CustomText>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskStartDetails.reviewStatus")}
                      </CustomText>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left", textTransform: "capitalize" }}>
                        {renderStatusLabel(startDetails?.validation?.review_status)}
                      </CustomText>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskStartDetails.uploadedFacePhoto")}
                      </CustomText>
                      {startDetails?.validation?.face_image_url ? (
                        <a
                          href={startDetails?.validation?.face_image_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: "inline-flex" }}
                        >
                          <img
                            src={startDetails?.validation?.face_image_url}
                            alt="Uploaded face"
                            style={{
                              width: 44,
                              height: 44,
                              borderRadius: 8,
                              objectFit: "contain",
                              border: "1px solid #E4E6EF",
                              cursor: "pointer",
                            }}
                            crossOrigin="anonymous"
                          />
                        </a>
                      ) : (
                        <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                          -
                        </CustomText>
                      )}
                    </Box>
                  </>
                )}
              </Box>
            )}


            {completeDetails?.timing && (
              <Box
                sx={{
                  border: "2px solid  #091E4224",
                  borderRadius: "10px",
                  px: 2,
                  py: 2,
                  mt: 1.5,
                  mb: 2.5,
                  // backgroundColor: "#FBFCFE",
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 19,
                    mb: 2,
                    mt: 0.5,
                    fontWeight: 700,
                    color: "#003149",
                    textAlign: "left",
                  }}
                >
                  {t("taskCompleteDetails.title")}
                </CustomText>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskCompleteDetails.scheduledEnd")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                    {formatDateTime(completeDetails?.timing?.scheduled_end_at)}
                  </CustomText>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskCompleteDetails.actualEnd")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                    {formatDateTime(completeDetails?.timing?.actual_end_at)}
                  </CustomText>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskCompleteDetails.completionStatus")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left", textTransform: "capitalize" }}>
                    {renderStatusLabel(completeDetails?.timing?.completion_time_status)}
                  </CustomText>
                </Box>

         

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskCompleteDetails.delayMinutes")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                    {renderDurationMinutes(completeDetails?.timing?.completion_delay_minutes)}
                  </CustomText>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                    {t("taskCompleteDetails.durationMinutes")}
                  </CustomText>
                  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                    {renderDurationMinutes(completeDetails?.duration_minutes)}
                  </CustomText>
                </Box>

                {completeDetails?.validation && (
                  <>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskCompleteDetails.faceValidated")}
                      </CustomText>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                        {renderBooleanLabel(completeDetails?.validation?.face_validated)}
                      </CustomText>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskCompleteDetails.locationValidated")}
                      </CustomText>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                        {renderBooleanLabel(completeDetails?.validation?.location_validated)}
                      </CustomText>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskCompleteDetails.systemValidationStatus")}
                      </CustomText>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left", textTransform: "capitalize" }}>
                        {renderStatusLabel(completeDetails?.validation?.system_validation_status)}
                      </CustomText>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskCompleteDetails.reviewStatus")}
                      </CustomText>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left", textTransform: "capitalize" }}>
                        {renderStatusLabel(completeDetails?.validation?.review_status)}
                      </CustomText>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskCompleteDetails.evidenceFilesCount")}
                      </CustomText>
                      {renderEvidenceGallery(completeDetails?.validation?.evidence_files)}
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                        {t("taskCompleteDetails.uploadedFacePhoto")}
                      </CustomText>
                      {completeDetails?.validation?.face_image_url ? (
                        <a
                          href={completeDetails?.validation?.face_image_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: "inline-flex" }}
                        >
                          <img
                            src={completeDetails?.validation?.face_image_url}
                            alt="Uploaded face"
                            style={{
                              width: 44,
                              height: 44,
                              borderRadius: 8,
                              objectFit: "cover",
                              border: "1px solid #E4E6EF",
                              cursor: "pointer",
                            }}
                      crossOrigin="anonymous"

                          />
                        </a>
                      ) : (
                        <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                          -
                        </CustomText>
                      )}
                    </Box>
                  </>
                )}
              </Box>
            )}

          

       
          


            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2.5,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.documents")}
            </CustomText>
            {/* <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 3,
                alignItems: "center",
                mb: 2,
              }}
            >
              <img src={document} style={{ width: 200, height: 200 }} />
              <img src={document2} style={{ width: 200, height: 200 }} />
            </Box> */}
            <Box
  sx={{
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    alignItems: "center",
    mb: 2,
  }}
>
  {task.attachments && task.attachments.length > 0 ? (
    task.attachments.map((fileUrl, idx) => {
      const fileName = fileUrl.split("/").pop(); // get file name
      const isPdf = fileUrl.toLowerCase().endsWith(".pdf");

      return (

        <Box
  key={idx}
  sx={{
    width: 200,
    height: 220,
    border: "1px solid #E4E6EF",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    p: 1.5,
    background: "#F9FAFB",
    position: "relative"
  }}
>
  {/* Top Preview */}
  <Box sx={{ textAlign: "center" }}>
    <img
      src={document1}
      alt="document"
      style={{
        width: 70,
        height: 70,
        objectFit: "contain",
        marginBottom: 8,
      }}
    />
    <Typography
      sx={{
        fontSize: 12,
        fontFamily: "Poppins, sans-serif",
        textAlign: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
      title={fileUrl.split("/").pop()}
    >
      {fileUrl.split("/").pop()}
    </Typography>
  </Box>

  {/* Bottom Right Button */}
<Box sx={{ textAlign: "center" }}>
  <CustomButton
    label={t("viewDocument")}
    size="small"
    variant="contained"
    onClick={async () => {
      if (!fileUrl) {
        toast.error(t("files.brokenLink"));
        return;
      }

      try {
        const res = await fetch(fileUrl, { method: "HEAD" });

        if (!res.ok) {
          throw new Error("File not found");
        }

        window.open(fileUrl, "_blank");
      } catch (error) {
        toast.error(t("files.brokenLink"));
      }
    }}
  />
</Box>
</Box>

      );
    })
  ) : (
    <Typography
      sx={{ fontSize: 14, color: "#5E5C5C", fontFamily: "Poppins, sans-serif" }}
    >
{t("noAttachments")}
    </Typography>
  )}
</Box>


          </Box>

    
        </Box>
      </Box>
      <Box>
{/* Add Comment */}
<Box sx={{ p: 2, background: "#fff", mt: 2, border: "1px solid #091E4224", borderRadius: 1 }}>
  <CustomText
    sx={{
      ...textStyles.h1,
      fontSize: 18,
      fontWeight: 600,
      color: "#000",
      textAlign: "left",
    }}
  >
    {t("projectManagement.addComment")}
  </CustomText>

  

<Box sx={{ display: "flex", gap: 1, mt: 1, alignItems: "center" }}>

  <label htmlFor="comment-attachment">
  {!commentFileUrl && !uploadingAttachment && (
    <AttachFileIcon sx={{ cursor: "pointer", color: "#006EC2" }} />
  )}

  {uploadingAttachment && (
    <CircularProgress size={24} sx={{ color: "#006EC2" }} />
  )}

  {commentFileUrl && !uploadingAttachment && (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      <img
         crossOrigin="anonymous"
        src={commentFileUrl}
        style={{
           width: 60,
        height: 60,
        borderRadius: "30px",
        objectFit: "cover",
        }}
      />

      <CloseRoundedIcon
        onClick={removeAttachment}
        sx={{
          position: "absolute",
          top: -6,
          right: -6,
         cursor: "pointer",
        color: "white",
        backgroundColor: "rgba(0,0,0,0.5)",
          borderRadius: "50%",
          fontSize: 18,
          p: 0.3,
        }}
      />
    </Box>
  )}
</label>

<input
  id="comment-attachment"
  type="file"
  accept="image/*"
  style={{ display: "none" }}
  onChange={handleFileChange}
/>

  {/* Comment input */}
  <input
    className="project_input"
    value={newComment}
    onChange={(e) => setNewComment(e.target.value)}
    placeholder={t("projectManagement.writeComment")}
    style={{ flex: 1, height: 40 }}
    disabled={sending}
  />

  {/* Add button */}
  <Button
    variant="contained"
    onClick={handleAddComment}
    disabled={sending}
    sx={{
      px: 2,
      backgroundColor: "#006EC2",
      color: "#fff",
      textTransform: "none",
      fontSize: 14,
      borderRadius: 1,
      height: 36,
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {sending ? t("projectManagement.add") : t("projectManagement.add")}
  </Button>
</Box>

  {/* Comments list */}
 <Box sx={{ mt: 2, borderRadius: 2 }}>
  {comments.length === 0 ? (
    <CustomText sx={{ ...textStyles.h1, fontSize: 14, color: "#5E5C5C" }}>
 {t("projectManagement.noComments")}
    </CustomText>
  ) : (
    comments.map((c) => (
      <Box key={c.id} sx={{ p: 2, borderBottom: "1px solid #EEF2F7" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.6 }}>
         
                {c.attachments && c.attachments.length > 0 && (
      <Box sx={{ display: "flex", gap: 1, mt: 1, flexWrap: "wrap" }}>
        {c.attachments.map((fileUrl, idx) => (
          <a
            key={idx}
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-flex" }}
          >
            <img
              crossOrigin="anonymous"
              src={fileUrl || emptyperson}
              alt={`attachment-${idx}`}
              style={{
                width: 60,
                height: 60,
                objectFit: "contain",
                borderRadius: "10px",
                border: "1px solid #ddd",
                cursor: "pointer",
              }}
            />
          </a>
        ))}
      </Box>
    )}
            <Box>
              <CustomText
                sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 600, color: "#100F0F" }}
              >
                {c.author_name || "-"}
              </CustomText>

              <CustomText
            sx={{ fontSize: 15, fontWeight: 400, color: "#5E5C5C", lineHeight: 1.5 }}
          >
            {(i18n.language?.split("-")[0] === "es" ? c.body_es : c.body_en) || c.body}
          </CustomText>
            
            </Box>
          </Box>

          {/* ✅ Comment badge */}
          <Box sx={{display:"flex",flexWrap:"wrap", alignItems:"center",gap:1,}}>
          <Box
            sx={{
              px: 2,
              py: 0.4,
              borderRadius: "4px",
              backgroundColor: "#E4E6EB",
              fontSize: 12,
              fontWeight: 500,
              color: "#003149",
              display: "inline-block",
                 fontFamily: 'Nunito Sans, sans-serif',
            }}
          >
            Comment
          </Box>
            <CustomText
                sx={{ ...textStyles.h1, fontSize: 13, color: "#5E5C5C", fontWeight: 400,
                     fontFamily: 'Nunito Sans, sans-serif',
                 }}
              >
                {formatDateTime(c.created_at)}
              </CustomText>
              </Box>
        </Box>

       
      </Box>
    ))
  )}
</Box>
</Box>

      <MapModal
  open={mapOpen}
  onClose={() => setMapOpen(false)}
  onContinue={handleMapContinue}
  taskLocation={{
    lat: task?.location_lat ? parseFloat(task.location_lat) : null,
    lng: task?.location_lng ? parseFloat(task.location_lng) : null,
    radius_m: task?.location_radius_m ? Number(task.location_radius_m) : 100,
  }}
/>
<FaceScanModal
  open={faceOpen}
  onClose={() => setFaceOpen(false)}
  onContinue={handleFaceContinue}
/>
<EvidenceModal
  open={evidenceOpen}
  onClose={() => setEvidenceOpen(false)}
  onSave={handleEvidenceSave}
/>
{updatingTaskStatus && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      bgcolor: "rgba(0,0,0,0.45)",
      zIndex: 1700,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      px: 2,
    }}
  >
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        px: 3,
        py: 2,
        minWidth: isMobile ? "90%" : 320,
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <CircularProgress size={24} />
      <Typography sx={{ fontFamily: "Poppins, sans-serif", color: "#172B4D", fontSize: 15 }}>
        {t("taskAlerts.updatingStatus")}
      </Typography>
    </Box>
  </Box>
)}
      </Box>
    </>
  );
};
export default TaskDetails




